import Service 							from "./../../Libs/Service";

import { Server } 						from "./Server";
import { Auth } 						from "./Auth";
import _ from "lodash";

let User = new Service({

	Name: "User",

	Libraries: [],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Signed Into Existing Publisher": function(publisherTitle) {

			Broadcast.call('Show Confirm', [{
				caption: 'Sign in',
				message: `You already have a company account, so you were signed in to ${publisherTitle === true ? 'your existing account' : `"${publisherTitle}"`}.`,
				confirmButtonText: 'OK',
				confirmButtonClass: 'btn-success',
				cancelButtonText: 'Close'
			}]);

		}

	},

	Actions: {

		"InvitationDetails": function(invitationDetails) {

			this.invitationDetails = invitationDetails;

			Broadcast.call("Invitation Details Changed", [invitationDetails]);

		},

		//Получение текущего пользователя (serverId - нода, на которой живёт его аккаунт)
		"User": function(user, data, size, serverId) {

			//Вторичное соединение с чужой нодой авторизуется тем же пользователем, но если нода его
			//не нашла (нода недоступна, пользователь не доехал по кластеру) - она присылает User: null
			//(Server/Services/Environment/Environment.mjs, initSecondaryConnection). Это не выход
			//из аккаунта: своего пользователя клиент терять не должен, иначе он показывает экран входа,
			//оставаясь авторизованным на ноде аккаунта (и тогда нода игнорирует действия экрана входа).
			if (!user && serverId && serverId !== Server.getPrimaryServerId()) return;

			let currentUser = this.currentUser;

			this.currentUser = user;

			//Помечаем что текущий пользователь загружен (даже если user === null, это означает что пользователь не авторизован и об этом теперь будет известно на клиенте)
			this.loaded = true;

			if (user) this.setUser(user, serverId);
			else Broadcast.call("Current User Changed");

			if (!currentUser) Broadcast.call("Current User Loaded");

		},

		//Получение данных других пользователей (serverId - нода, с которой пришли данные)
		"Users": function(users, data, size, serverId) {

			this.setUsers(users, serverId);

		},

		// ИИ бюджет пользователя (приходит только самому пользователю и супер-админам)
		"UserAIBudget": function(userAIBudget, data, size, serverId) {

			this.getServerMap(this.AIBudgetsByServer, serverId || this.NodeServerId)[userAIBudget.id] = userAIBudget;

			Broadcast.call("User AI Budget Changed", [userAIBudget.id]);

		},

		// Список изменений ИИ бюджета пользователя (добавления, отнимания и переводы, новые сверху)
		"UserAIBudgetLog": function(userAIBudgetLog, data, size, serverId) {

			this.getServerMap(this.AIBudgetLogsByServer, serverId || this.NodeServerId)[userAIBudgetLog.userId] = userAIBudgetLog.records;

			Broadcast.call("User AI Budget Changed", [userAIBudgetLog.userId]);

		},

		"FullUsersOnlineStatus": function(usersOnlineStatus) {

			this.usersOnlineStatus.Users = _.cloneDeep(usersOnlineStatus.Users || {});
			this.usersOnlineStatus.Unauthorized = usersOnlineStatus.Unauthorized || {};

			_.each(this.usersOnlineStatus.Users, userData => {

				this.transformUserOnlineStatusData(userData);

			});

			Broadcast.call("Users Online Status Changed");

		},

		"UserOnlineStatus": function(data) {

			let oldUserOnlineStatus = this.usersOnlineStatus.Users[data.userId];
			let newUserOnlineStatus = data.userOnlineStatus;

			if (newUserOnlineStatus) {

				this.usersOnlineStatus.Users[data.userId] = newUserOnlineStatus;

				this.transformUserOnlineStatusData(newUserOnlineStatus);

				if (oldUserOnlineStatus) Broadcast.call("User Online Status Changed");
				else Broadcast.call("User Online Status Added");

			} else if (oldUserOnlineStatus) {

				delete this.usersOnlineStatus.Users[data.userId];

				Broadcast.call("User Online Status Removed");

			}

		},

		"UserOnlineStatusAction": function(data) {

			let userOnlineStatus = this.usersOnlineStatus.Users[data.userId];

			if (userOnlineStatus) {

				userOnlineStatus.actions.push(data.action);

				this.transformUserOnlineStatusData(userOnlineStatus);

				Broadcast.call("User Online Status Changed");

			}

		},

	},

	init() {

		//Текущий пользователь
		this.User = null;

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id пользователей
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap).
		//Пользователи рабочей ноды - активные карты Users
		this.UsersByServer = {};
		this.AIBudgetsByServer = {};
		this.AIBudgetLogsByServer = {};

		this.usersOnlineStatus = {
			Users: {}
		};

		// Активные карты - карты рабочей ноды
		this.useServer(0);

		this.COUNTRIES = {
			"au": "Australia",
			"at": "Austria",
			"az": "Azerbaijan",
			"ax": "Aland",
			"al": "Albania",
			"dz": "Algeria",
			"um": "Minor",
			"vi": "U.S.",
			"as": "American",
			"ai": "Anguilla",
			"ao": "Angola",
			"ad": "Andorra",
			"aq": "Antarctica",
			"ag": "Antigua",
			"ar": "Argentina",
			"am": "Armenia",
			"aw": "Aruba",
			"af": "Afghanistan",
			"bs": "Bahamas",
			"bd": "Bangladesh",
			"bb": "Barbados",
			"bh": "Bahrain",
			"bz": "Belize",
			"by": "Belarus",
			"be": "Belgium",
			"bj": "Benin",
			"bm": "Bermuda",
			"bg": "Bulgaria",
			"bo": "Bolivia",
			"ba": "Bosnia",
			"bw": "Botswana",
			"br": "Brazil",
			"io": "British",
			"vg": "British",
			"bn": "Brunei",
			"bf": "Burkina",
			"bi": "Burundi",
			"bt": "Bhutan",
			"vu": "Vanuatu",
			"va": "Vatican",
			"gb": "United",
			"hu": "Hungary",
			"ve": "Venezuela",
			"tl": "East",
			"vn": "Vietnam",
			"ga": "Gabon",
			"ht": "Haiti",
			"gy": "Guyana",
			"gm": "Gambia",
			"gh": "Ghana",
			"gp": "Guadeloupe",
			"gt": "Guatemala",
			"gn": "Guinea",
			"gw": "Guinea-Bissau",
			"de": "Germany",
			"gi": "Gibraltar",
			"hn": "Honduras",
			"hk": "Hong",
			"gd": "Grenada",
			"gl": "Greenland",
			"gr": "Greece",
			"ge": "Georgia",
			"gu": "Guam",
			"dk": "Denmark",
			"cd": "DR",
			"dj": "Djibouti",
			"dm": "Dominica",
			"do": "Dominican",
			"eu": "European",
			"eg": "Egypt",
			"zm": "Zambia",
			"eh": "Western",
			"zw": "Zimbabwe",
			"il": "Israel",
			"in": "India",
			"id": "Indonesia",
			"jo": "Jordan",
			"iq": "Iraq",
			"ir": "Iran",
			"ie": "Ireland",
			"is": "Iceland",
			"es": "Spain",
			"it": "Italy",
			"ye": "Yemen",
			"kp": "North",
			"cv": "Cape",
			"kz": "Kazakhstan",
			"ky": "Cayman",
			"kh": "Cambodia",
			"cm": "Cameroon",
			"ca": "Canada",
			"qa": "Qatar",
			"ke": "Kenya",
			"cy": "Cyprus",
			"kg": "Kyrgyzstan",
			"ki": "Kiribati",
			"cn": "China",
			"cc": "Cocos",
			"co": "Colombia",
			"km": "Comoros",
			"cr": "Costa",
			"ci": "Ivory",
			"cu": "Cuba",
			"kw": "Kuwait",
			"la": "Laos",
			"lv": "Latvia",
			"ls": "Lesotho",
			"lr": "Liberia",
			"lb": "Lebanon",
			"ly": "Libya",
			"lt": "Lithuania",
			"li": "Liechtenstein",
			"lu": "Luxembourg",
			"mu": "Mauritius",
			"mr": "Mauritania",
			"mg": "Madagascar",
			"yt": "Mayotte",
			"mo": "Macau",
			"mk": "Republic",
			"mw": "Malawi",
			"my": "Malaysia",
			"ml": "Mali",
			"mv": "Maldives",
			"mt": "Malta",
			"ma": "Morocco",
			"mq": "Martinique",
			"mh": "Marshall",
			"mx": "Mexico",
			"mz": "Mozambique",
			"md": "Moldova",
			"mc": "Monaco",
			"mn": "Mongolia",
			"ms": "Montserrat",
			"mm": "Myanmar",
			"na": "Namibia",
			"nr": "Nauru",
			"np": "Nepal",
			"ne": "Niger",
			"ng": "Nigeria",
			"an": "Netherlands",
			"nl": "The",
			"ni": "Nicaragua",
			"nu": "Niue",
			"nc": "New",
			"nz": "New",
			"no": "Norway",
			"ae": "UAE",
			"om": "Oman",
			"cx": "Christmas",
			"ck": "Cook",
			"hm": "Heard",
			"pk": "Pakistan",
			"pw": "Palau",
			"ps": "Palestine",
			"pa": "Panama",
			"pg": "Papua",
			"py": "Paraguay",
			"pe": "Peru",
			"pn": "Pitcairn",
			"pl": "Poland",
			"pt": "Portugal",
			"pr": "Puerto",
			"cg": "Republic",
			"re": "Reunion",
			"ru": "Russia",
			"rw": "Rwanda",
			"ro": "Romania",
			"us": "USA",
			"sv": "El",
			"ws": "Samoa",
			"sm": "San",
			"st": "Sao",
			"sa": "Saudi",
			"sz": "Swaziland",
			"sj": "Svalbard",
			"mp": "Northern",
			"sc": "Seychelles",
			"sn": "Senegal",
			"vc": "St.",
			"kn": "Saint",
			"lc": "Saint",
			"pm": "Saint",
			"rs": "Serbia",
			"cs": "Serbia",
			"sg": "Singapore",
			"sy": "Syria",
			"sk": "Slovakia",
			"si": "Slovenia",
			"sb": "Solomon",
			"so": "Somalia",
			"sd": "Sudan",
			"sr": "Suriname",
			"sl": "Sierra",
			"su": "USSR",
			"tj": "Tajikistan",
			"th": "Thailand",
			"tw": "Republic",
			"tz": "Tanzania",
			"tg": "Togo",
			"tk": "Tokelau",
			"to": "Tonga",
			"tt": "Trinidad",
			"tv": "Tuvalu",
			"tn": "Tunisia",
			"tm": "Turkmenistan",
			"tr": "Turkey",
			"ug": "Uganda",
			"uz": "Uzbekistan",
			"ua": "Ukraine",
			"uy": "Uruguay",
			"fo": "Faroe",
			"fm": "Micronesia",
			"fj": "Fiji",
			"ph": "Philippines",
			"fi": "Finland",
			"fk": "Falkland",
			"fr": "France",
			"gf": "French",
			"pf": "French",
			"tf": "French",
			"hr": "Croatia",
			"cf": "CAR",
			"td": "Chad",
			"me": "Montenegro",
			"cz": "Czech",
			"cl": "Chile",
			"ch": "Switzerland",
			"se": "Sweden",
			"lk": "Sri",
			"ec": "Ecuador",
			"gq": "Equatorial",
			"er": "Eritrea",
			"ee": "Estonia",
			"et": "Ethiopia",
			"za": "South",
			"kr": "Republic",
			"gs": "South",
			"jm": "Jamaica",
			"jp": "Japan",
			"bv": "Bouvet",
			"nf": "Norfolk",
			"sh": "Saint",
			"tc": "Turks",
			"wf": "Wallis"
		};

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Users[userId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Users = this.getServerMap(this.UsersByServer, serverId);
		this.AIBudgets = this.getServerMap(this.AIBudgetsByServer, serverId || this.NodeServerId);
		this.AIBudgetLogs = this.getServerMap(this.AIBudgetLogsByServer, serverId || this.NodeServerId);

	},

	//Пользователи приходят с конкретной ноды: кладём их в карты этой ноды
	setUsers(users, serverId) {

		_.each(users, user => {

			this.setUser(user, serverId);

		});

	},

	// Пользователь по id (активные карты - пользователи рабочей ноды)
	getUser(userId) {

		let user = this.Users[userId];

		if (user) return user;

		//Текущий пользователь живёт на своей ноде и может быть не в картах открытой ноды
		if (this.currentUser && this.currentUser.id === userId) return this.currentUser;

		return null;

	},

	// Все пользователи рабочей ноды одним списком
	getUsers() {

		return _.values(this.Users);

	},

	// Пользователи одного паблишера (активные карты - пользователи рабочей ноды)
	getUsersByPublisher(publisherId) {

		return _.filter(this.Users, user => user["publisher_id"] === publisherId);

	},

	setUser(newUser, serverId) {

		serverId = serverId || this.NodeServerId;

		let users = this.getServerMap(this.UsersByServer, serverId),
			oldUser = users[newUser.id];

		users[newUser.id] = newUser;

		//Текущий пользователь приходит со своей ноды: его копия всегда актуальна
		if (this.currentUser?.id === newUser.id) this.currentUser = newUser;

		if (!newUser.options) newUser.options = {};
		if (!newUser.options.access) newUser.options.access = {};

		let eventPrefixes = ["User"];
		if (this.currentUser?.id === newUser?.id || this.currentUser?.id === oldUser?.id) eventPrefixes.push("Current User");

		this.broadcastChanges(oldUser, newUser, eventPrefixes);

	},

	//Адрес аватара пользователя (если аватара нет - своя иконка по умолчанию).
	//Аватар хранится в файлах ноды паблишера пользователя, поэтому относительный путь
	//дополняем адресом этой ноды
	getPhotoUrl(user) {

		let photo = user ? user.photo : '';

		if (!photo) return Auth.getNodeUrlForServer(Publisher.getServerIdForPublisher(user ? user['publisher_id'] : 0), '/Images/Users/default-avatar.png');

		if (photo.indexOf('/') === 0) return Auth.getNodeUrlForServer(Publisher.getServerIdForPublisher(user['publisher_id']), photo);

		return photo;

	},

	toggleFeature(userId, featureName, isEnabled) {

		console.log(isEnabled)

		Server.sendToServer({
			SetUserFeature: {
				userId,
				featureName,
				isEnabled
			}
		});

	},

	transformUserOnlineStatusData(userData) {

		let userActionsGrouped = {};

		_.each(userData.actions, action => {

			this.transformUserOnlineStatusAction(action);

			this.pushUserOnlineStatusActionToGroup(userActionsGrouped, action);

		});

		userData.actionsGrouped = _.reverse(_.orderBy(_.values(userActionsGrouped), 'date'));

	},

	transformUserOnlineStatusAction(action) {

		if (typeof action[0] === 'string') action[0] = new Date(action[0]);

	},

	pushUserOnlineStatusActionToGroup(actionsGrouped, action) {

		let date = action[0].toLocaleDateString();

		if (!actionsGrouped[date]) actionsGrouped[date] = {date: date, title: date, actions: []};

		if (date === (new Date()).toLocaleDateString()) actionsGrouped[date].title = 'Today';
		else if (date === (new Date(Date.now() - 24 * 3600 * 1000)).toLocaleDateString()) actionsGrouped[date].title = 'Yesterday';

		actionsGrouped[date].actions.push(action);

	},

	getLastActiveVersionData(userData) {

		let connections = _.sortBy(userData.connections, "versionTime");
		return connections[connections.length-1];

	},

	logout() {

		// Токен хранится на клиенте, поэтому выход - это удаление токена и сброс пользователя на сервере
		Auth.clearToken();

		// Выход касается аккаунта, а значит ноды аккаунта (первичного соединения): запросы клиента
		// по умолчанию уходят на ноду выбранного паблишера, и тогда сбросилось бы вторичное соединение,
		// а клиент остался бы с текущим пользователем (вторичное соединение его не сбрасывает)
		Server.sendToSocket({
			Logout: true
		}, Server.getPrimaryServerId());

	}

});

window.User = User;

export { User }

